import { Component, Input } from '@angular/core';

@Component({
    selector: 'ig-success-wrap',
    templateUrl: './success.wrap.component.html',
    styleUrls: ['./success.wrap.component.scss']
})
export class SuccessWrapComponent {
    @Input() public text = 'Operation Succeed!';
    @Input() public showSuccess = false;
    @Input() public hideAfter = 3000;
    @Input() public delay = 0;

    constructor() {
    }

    public success() {
        setTimeout(() => {
            this.showSuccess = true;
            setTimeout(() => {
                this.showSuccess = false;
            }, this.hideAfter);
        }, this.delay);
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/success.wrap/success.wrap.component.ts